import { Activity } from 'lucide-react'
import { ReportPageLayout, type ReportColumn, type SummaryStat } from './ReportPageLayout'
import { generateSystemPerformanceReport } from '@/src/lib/api/admin-reports'
import type { SystemPerformanceReportData } from '@/src/types/admin/reports'

const fmtN = (v: unknown) => Number(v ?? 0).toLocaleString('th-TH')
const fmt2 = (v: unknown) =>
  Number(v ?? 0).toLocaleString('th-TH', { minimumFractionDigits: 2 })

const columns: ReportColumn[] = [
  { key: 'bank_code', label: 'ธนาคาร' },
  { key: 'total_requests', label: 'คำขอทั้งหมด', format: fmtN },
  { key: 'successful_requests', label: 'สำเร็จ', format: fmtN },
  {
    key: 'success_rate_pct',
    label: 'Success Rate',
    format: (v) => `${Number(v ?? 0).toFixed(1)}%`,
  },
  { key: 'avg_response_ms', label: 'เฉลี่ย (ms)', format: (v) => `${Number(v ?? 0).toFixed(0)}` },
  { key: 'p95_response_ms', label: 'P95 (ms)', format: (v) => `${Number(v ?? 0).toFixed(0)}` },
  { key: 'total_errors', label: 'Errors', format: fmtN },
]

function extractRows(data: unknown) {
  const d = data as SystemPerformanceReportData
  return (d?.bank_performance ?? []) as unknown as Record<string, unknown>[]
}

function extractSummary(data: unknown): SummaryStat[] {
  const d = data as SystemPerformanceReportData
  const cache = d?.cache
  if (!cache) return []
  return [
    { label: 'Cache Hit Rate', value: `${Number(cache.avg_hit_rate_pct ?? 0).toFixed(1)}%` },
    {
      label: 'API Calls ประหยัดได้',
      value: fmtN(cache.api_calls_avoided),
      description: 'คำขอที่ไม่ต้องส่งไปธนาคาร',
    },
    {
      label: 'ประหยัดค่าใช้จ่าย',
      value: `฿${fmt2(cache.cost_saved_thb)}`,
      description: 'ค่าใช้จ่าย API ที่ประหยัดได้',
    },
  ]
}

export default function AdminReportPerformance() {
  return (
    <ReportPageLayout
      title="รายงานประสิทธิภาพระบบ"
      description="Bank API health, SLA, cache stats"
      audience="เทคนิค"
      icon={Activity}
      columns={columns}
      fetchFn={generateSystemPerformanceReport}
      extractRows={extractRows}
      extractSummary={extractSummary}
      filenamePrefix="system_performance"
    />
  )
}
